import { mapState } from 'vuex';

export default {
    name: 'settingToggle',
    props: {
        setting : String,
        parentalDefControl : Boolean
    },

    data : function(){

        return {
            loading : false,
            value : '',
            label : '',
            icons: [{
                icon: "fas fa-check",
                id: 'yes'
            },
            {
                icon: "fas fa-times",
                id: 'no'
            }],

            defaultValue : null
        }

    },

    beforeDestroy (){
        this.core.off('settingsUpdated', 'settingToggle' + this.setting)
    },

    created () {

        this.load()

        this.core.on('settingsUpdated', 'settingToggle' + this.setting, (type) => {
            this.load()
		})
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        gpath : function(){
            return this.setting.split('.')[0]
        },

        spath : function(){
            return this.setting.split('.')[1]
        },

        cvalue : function(){
            if(this.value) return 'yes'
            return 'no'
        }
    }),

    methods : {
        set : function(v){

            this.core.parental('settings', {

			}, () => {

                if(v == 'yes') this.value = true
                else this.value = ''

                this.loading = true
                

                this.core.settings[this.gpath].set(this.spath, this.value).then(r => {

                }).catch(e => {

                    this.value == ''

                    this.$store.commit('icon', {
                        icon: 'error',
                        text : e
                    })

                }).finally(() => {
                    this.loading = false
                })

            }, () => {

                if(!this.parentalDefControl) return true

                var vv = v == 'yes' ? true : false

                if (vv != this.defaultValue) return true

            })

            
        },

        load : function(){
            this.loading = true

            this.core.settings[this.gpath].getall().then(settings => {
                this.label = settings[this.spath].name
                this.value = settings[this.spath].value
                this.defaultValue = this.core.metasettings.local[this.gpath][this.spath].default()
                console.log(this.core.metasettings, this.gpath, this.spath)
                console.log(this.core.metasettings.local[this.gpath][this.spath])

                console.log('this.defaultValue ', this.defaultValue )

                return Promise.resolve()
            }).finally(() => {
                this.loading = false
            })
        }
    },
}